import type { InfoSlidesEvent, ScenarioEvent, WalkthroughEvent } from '@shared-types/frontend-scenario-definition';
export type { PeriodKey, Period } from '@shared-types/scenario-definition';
export type {
    FrontendScenarioDefinition,
    NavigationBarItem,
    NavigationBarJsonDefinition,
    InfoSlidesEvent,
    ScenarioEvent,
    WalkthroughEvent,
    WalkthroughStepElement,
} from '@shared-types/frontend-scenario-definition';

export function isInfoSlidesEvent(event: ScenarioEvent): event is InfoSlidesEvent {
    return 'slides' in event;
}

export function isWalkthroughEvent(event: ScenarioEvent): event is WalkthroughEvent {
    return 'steps' in event;
}
